/* global define, SU, zipTools, Handlebars, google */
var redirectUrl = null;

define('zipTools',[
  'jquery',
  'lib/util/buildGoTo',
  'lib/util/tda.config',
  'lib/getParameterByName',
  'cookies',
  'storageUtil', // move to dependency once all scenarios can be tested
  'googlemaps',

  // side effect includes. TODO: move & test cookies & storageUtil to proper
  'lib/helpers/grouped_each', // used by dealer-confirm-modal
  'firstMoverParticipant',
  'bootstrapModal',
  'bootstrapTransition'
], function (
  $,
  buildGoTo,
  tdaConfig,
  getParameterByName,
  cookies,
  storageUtil,
  googleMaps
) {
  window.zipTools = {
    transferZipCookieTTL: (5 * 60 * 1000),
    isInitialZipCodeReceived: false,
    redirectPath: '',
    init: function () {
      var self = this;
      var gxpParticipant = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';

      $(window).on('INITAL_ZIP_CODE_RECEIVED', function () {
        self.isInitialZipCodeReceived = true;
      });

      // TODO: move this out of zip-tools
      // REWRITE TDA, NOT NATIONAL 404 LINKS FOR DR
      if ($('div[data-component-name="404"]').length && tdaConfig.tda.code !== 'WWW') {
        var homelink = '/' + tdaConfig.site.context_url;
        $('.subhead-404').find('a').attr('href', homelink);
        $('#offer-link-404').attr('href', homelink + '/offers');

        // MIDDLE VEHICLE LINK. COULD BE FORCED TO CAMRY.
        var newfindvehicleLink = homelink + '/vehicles/';
        var findvehilclelink = $('.find-vehicle-404').parent().parent().find('a').attr('href');
        if (findvehilclelink) {
          // HANDLE THE CAMRY BEING THE MIDDLE LINK.
          if (findvehilclelink.indexOf('camry') !== -1) {
            newfindvehicleLink += 'camry';
          }
        }
        // console.log(' ::: newfindvehicleLink', newfindvehicleLink);
        $('.find-vehicle-404').parent().parent().find('a').attr('href', newfindvehicleLink);

        // BOTTOM FULL ROW
        var fullrowlinks = $('.full-row').find('a');
        var frlink = $(fullrowlinks[0]);
        var inventorylink = homelink + '/inventory';
        // console.log(' ::: inventorylink:', inventorylink);
        frlink.attr('href', inventorylink);

        // BAT-2426: 404 page redesign. check to see if this is the confirmation xsl data component 404.
        if (tdaConfig.tda.code === 'SET10') {
          var links = $('.full-row').find('a');
          var link = $(links[0]);
          link.attr('href', 'http://explore.setbuyatoyota.com/');
          self.redirectSETDealer = true; // REDIRECT FOR DEALERS. BAT-2426
        }
        // BAT-2436 if user is on expired offers page (we use the 404 component within Offer-Details.xsl), auto-redirect to /offers
        // not if you're in TeamSite though
        if ((window.location.pathname.indexOf('offer-detail') !== -1) && (window.location.href.indexOf('teamsite') === -1)) {
          setTimeout(function () {
            window.location.href = '/' + tdaConfig.site.context_url + '/offers/';
          }, 5000);
        }
      }

      if (tdaConfig.tda.code === 'WWW') {
        $(window).trigger('INITAL_ZIP_CODE_RECEIVED');
      } else if (storageUtil.isConfirmedZip() && !self.transferZip()) {
        self.setInitialZip(storageUtil.getZip(), true);
      } else if (!storageUtil.checkSessionStorage('canDisplayZipModal')) {
        self.setDefaultZip(); // we are not permitted to prompt for zip on their first landing
        storageUtil.setSessionStorage('canDisplayZipModal', 'true'); // not their first landing, we may prompt (next time). Set SessionStorage that will allow that to happen;
      } else if (gxpParticipant) {
        self.setDefaultZip();
      } else {
        self.detectZip();
      }
      self.initListeners();
    },

    initListeners: function () {
      var self = this;
      // autolocate buttons in our modals
      $('.js-autolocate').on('click', function () {
        self.autoLocate();
      });

      // handle keys
      $('#nav-zip-code input').keydown(function (e) {
        self.numericInput(e);
      }).keypress(function (e) {
        self.numericInput(e);
      });

      $('input[name=zip]').keydown(function (e) {
        if (e.keyCode === 9 || e.keyCode === 16) { // ADA
          return;
        }
        self.numericInput(e);
      }).keypress(function (e) {
        self.numericInput(e);
      });

      // validate and store zip modals
      $('input[name=modal-zip]').keydown(function (e) {
        self.numericInput(e);
      }).keypress(function (e) {
        self.numericInput(e);
      });

      // validate user input zip
      $('input[name=customerZipCode]').keydown(function (e) {
        self.numericInput(e);
      }).keypress(function (e) {
        self.numericInput(e);
      });
    },

    detectZip: function () {
      var self = this;
      var currentTDACode = self.getCurrentTDACode();
      var skipGeo = cookies.getItem('geoIgnore');
      if (currentTDACode.toUpperCase() === 'WWW') {
        if (!self.verifyConfirmedZip()) {
          if (skipGeo === 'true') {
            $(window).trigger('INITAL_ZIP_CODE_RECEIVED');
          } else {
            window.zipTools.initializeMaps();
          }
        }
      // TDA sites
      } else if (getParameterByName('originating_zip_code') !== '') {
        self.changeZip(undefined, getParameterByName('originating_zip_code'), undefined, undefined, true);
      } else if (!self.transferZip() && !self.verifyConfirmedZip()) {
        if (skipGeo === 'true') {
          self.setDefaultZip();
        } else {
          window.zipTools.initializeMaps();
        }
      }
    },

    setInitialZipAndPromptForUserZip: function (newZip) {
      var _this = this;
      // set initial zip
      var regPostalCode = new RegExp('\^\d{5}(-\d{4})?');
      if (regPostalCode.test(newZip) === false) {
        _this.setDefaultZip();
      } else {
        _this.setInitialZip(newZip, false);
      }
      // prompt for zip confirmation if transferring
      var defaultTDAZip = tdaConfig.tda.default_zip;
      var newTDACode = _this.getTDA(newZip, function (jsonData, oldTDA) {
        // find the dealer object so we can check its TDA
        var newTDA = '';
        var oldTDA = SU.getTDA();
        newDealer = jsonData.entityList[0];
        newTDA = newDealer.tdaCode;
        if (newTDA !== oldTDA) {
          _this.promptUserForZip(newZip, undefined);
        }
      });
    },

    // Used when we know we'll have a zip (IE: when zip is confirmed or from a geosuccess)
    // avoids prompting for confirmation
    setInitialZipAndTransfer: function (newZip) {
      var self = this;
      var redirectPath = window.zipTools.redirectPath || '/' + tdaConfig.site.context_url;
      var expire = new Date(Date.now() + self.transferZipCookieTTL);
      var gotourl;
      storageUtil.setZip(newZip);
      storageUtil.setConfirmedZip(true);
      cookies.setItem('transferZip', newZip, expire, '/', cookies.getCrossDomainCookieDomain());
      self.updateZipFields(newZip);
      self.getTDA(newZip, function (jsonData) {
        gotourl = buildGoTo(jsonData.entityList[0].tdaCode, redirectPath);
        window.location.href = gotourl;
      });
    },

    setInitialZip: function (newZip, isConfirmedZip) {
      // console.log('setInitialZip')
      var _this = this;
      // update zip
      SU.setZip(newZip);

      /* $('a').each(function(index) {
        if($(this).attr('href') != null && $(this).attr('href') !== '' && typeof $(this).attr('href') !== 'undefined' && $.trim($(this).attr('href')) !== '' && $(this).attr('href').indexOf('http://www.toyota.com/configurator/') !== -1){
          $(this).attr('href', 'http://www.toyota.com/configurator/?zipcode=' + SU.getZip());
        }
      }); */
      // add zip code to parts and service for link outs
      // set zip confirmed (false if not passed in)
      SU.setConfirmedZip(!!isConfirmedZip);

      // update UI
      _this.updateZipFields(newZip);
      $(window).trigger('INITAL_ZIP_CODE_RECEIVED');
    },

    setDefaultZip: function () {
      storageUtil.setZip(tdaConfig.tda.default_zip);
      storageUtil.setConfirmedZip(false);
      // Need to update configurator links
      if ($('a[data-omni_link="build-and-price"]').length) {
        $('a[data-omni_link="build-and-price"]').attr('href', 'http://www.toyota.com/configurator/?zipcode=' + SU.getZip());
      }
      $(window).trigger('INITAL_ZIP_CODE_RECEIVED');
      if ($('.dZip').length) {
        $('.dZip').show();
      }
    },

    transferZip: function () {
      var self = this;
      var isZipTransferred = false;
      var newZip = cookies.getItem('transferZip');
      var crossDomainCookieDomain = self.getCrossDomainCookieDomain();
      // If we have a valid transferZip we need to use it and mark as confirmed
      if (newZip && self.isZipFormatValid(newZip)) {
        cookies.removeItem('transferZip', '/', crossDomainCookieDomain);
        self.setInitialZip(newZip, true);
        isZipTransferred = true;
      }
      return isZipTransferred;
    },

    verifyConfirmedZip: function () {
      // console.log('verifyConfirmedZip');
      var _this = this;
      var isConfirmedZipVerified = false;

      // do we already have a confirmed zip?
      if (SU.getZip() !== undefined && SU.isConfirmedZip()) {
        // We already have a zip and it is confirmed, so we need to jump
        // through the hoops of setting up the DOM to use this zip, so we invoke setInitialZip()
        _this.setInitialZip(SU.getZip(), true);
        isConfirmedZipVerified = true;
      }
      return isConfirmedZipVerified;
    },

    promptUserForZip: function (prefillZip, redirectPath, ignoreDismiss) {
      redirectPath = redirectPath || zipTools.redirectPath; // first point of contact for a redirectPath
      var _this = this;
      // check if there is already a different modal open (like the tda redirect modal on slp with ?dealerCode that does not match current TDA)
      // console.log('promptUserForZip');
      if ($('body').hasClass('modal-open') && !$('#zip-modal-prompt').filter(':visible').length) {
      // a different modal is open, so try again once that modal is closed
        setTimeout(function () {
          _this.promptUserForZip(prefillZip, redirectPath);
        }, 1000);
      } else {
        redirectPath = redirectPath || '/';
        // console.log("redirecting : " + redirectPath);

        if (prefillZip) {
          _this.showPromptUserZipModal(undefined, prefillZip, redirectPath, undefined, true);
        } else {
          _this.showPromptUserZipModal(undefined, undefined, redirectPath, undefined, true);
        }
        // BAT25-329 added this parameter so modal does not self dismiss.
        if (!ignoreDismiss) {
          setTimeout(function () {
            $('#zip-modal-prompt').modal('hide');
          }, 15000);
        }
      }
    },

    geoLocationZip: {
      timeoutDelay: 8000,
      timeoutId: undefined,
      detect: function (successCallback, failCallback) {
        var _this = this;
        // if no response from user after a delay, just invoke the failCallback (setDefaultZip)
        _this.timeoutId = setTimeout(failCallback, _this.timeoutDelay);

        navigator.geolocation.getCurrentPosition(function (pos) {
          // ALLOWED geolocation
          // clear geolocation timeout
          clearTimeout(_this.timeoutId);
          SU.setLatLong(pos.coords.latitude, pos.coords.longitude);
          // get zip from google maps based on lat/long
          window.zipTools.getZipFromLatLong(pos.coords.latitude, pos.coords.longitude, successCallback, failCallback);
        }, function () {
          // DID NOT allow geolocation (or fail)
          // navigator.geolocation.getCurrentPosition error callback:
          clearTimeout(_this.timeoutId); // clear geolocation timeouts
          // fail
          cookies.setItem('geoIgnore', 'true', new Date(Date.now() + window.zipTools.transferZipCookieTTL), '/', window.zipTools.getCrossDomainCookieDomain());
          if (failCallback) {
            failCallback();
          }
        });
      }
    },

    getZipFromLatLong: function (lat, longitude, successCallback, failCallback) {
      var _this = this;
      googleMaps()
        .then(function (google) {
          var point;
          point = new google.maps.LatLng(lat, longitude);
          new google.maps.Geocoder().geocode({
            latLng: point
          }, function (res, status) {
            var addressComponentsGrepResults = [];
            var zip;
            if (google.maps.GeocoderStatus.OK === status && typeof res[0] !== 'undefined') {
              addressComponentsGrepResults = $.grep(res[0].address_components, function (element, index) {
                return (-1 < $.inArray('postal_code', element.types));
              });
              if (addressComponentsGrepResults.length) {
                zip = addressComponentsGrepResults[0].short_name;
              }
              new google.maps.Geocoder().geocode({ 'address': zip }, function (result, status) {
                var state = 'N/A';
                // start loop to get state from zip
                for (var component in result[0]['address_components']) {
                  for (var i in result[0]['address_components'][component]['types']) {
                    if (result[0]['address_components'][component]['types'][i] === 'administrative_area_level_1') {
                      var state = result[0]['address_components'][component]['long_name'];
                      SU.setState(state);
                    }
                  }
                }
              });
              if (zip) {
                if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip) == false) {
                  if (failCallback) {
                    failCallback();
                  }
                } else {
                  if (successCallback) {
                    successCallback(zip);
                  }
                }
              } else {
                if (failCallback) {
                  failCallback();
                }
              }
            } else {
              if (failCallback) {
                failCallback();
              }
            }
          });
        })
        .catch(function (err) {
          console.warn('error in googleMaps:', err);
          $.proxy(_this.setDefaultZip, _this);
        });
    },

    getLatLongFromAddress: function (address, successCallback, failCallback) {
      // console.log('getLatLongFromAddress');
      // BAT-2044, turn 'PR' into 'Puerto Rico' and 'VI' into 'Virgin Islands' for proper results
      if (address.indexOf(',') > -1) {
        var addressArr = address.split(',');
        var state = addressArr[1].trim().toLowerCase();
        if (state === 'pr') {
          address = addressArr[0] + ', Puerto Rico';
        } else if (state === 'vi') {
          address = addressArr[0] + ', Virgin Islands';
        }
      }

      // BAT-2010 for city/state dealer search
      googleMaps()
        .then(function (google) {
          new google.maps.Geocoder().geocode({
            address: address,
            componentRestrictions: { country: 'US' }
          }, function (results, status) {
            var lat;
            var longitude;
            if (status === google.maps.GeocoderStatus.OK && typeof results[0] !== 'undefined') {
              lat = results[0].geometry.location.lat();
              longitude = results[0].geometry.location.lng();

              if (lat && longitude) {
                // got a zip from google
                if (successCallback) {
                  successCallback(lat, longitude);
                }
              } else {
                if (failCallback) { failCallback(); }
              }
            } else {
              if (failCallback) { failCallback(); }
            }
          });
        })
        .catch(function (err) { console.warn('error in getLatLongFromAddress: ', err); });
    },

    // shim. TODO: move refs to zipTools.getCrossDomainCookieDomain() to cookies, permanently
    getCrossDomainCookieDomain: function () {
      return cookies.getCrossDomainCookieDomain();
    },

    updateZipFields: function (zip) {
      var $activeElement = $(document.activeElement);
      var $allZipFields = $('input[data-storage="userZip"]');
      var $activeZipField = $allZipFields.filter($activeElement);
      var $inactiveZipFields = $allZipFields.not($activeElement);

      // update inactive zip fields
      $inactiveZipFields.val(zip);
      // BAT-2530, initial load doesnt realize if zip has been entered automatically via line above
      if ($('#search-value').length > 0) {
        $('#search-value').trigger('change');
      }

      // update active zip field if user has not started editing it yet
      if ($activeZipField.length && !$activeZipField.val().length) {
        $activeZipField.val(zip);
      }
    },

    // only allow numbers
    numericInput: function (e, isKeyId) {
      // console.log('NUMERIC INPUT ', e, isKeyId);
      // handle firefox
      var keyID;
      if (isKeyId) {
        // var char = e.data;
        // console.log('e', e);
        keyID = e.which;// char.charCodeAt(0);
      } else {
        keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
      }
      // console.log('NUMERIC >> keyID', keyID, ' keyCode', e.keyCode);
      //  var typedChar = String.fromCharCode(keyID);
      //  console.log('typedChar', typedChar)
      // Allow: backspace, delete, tab, escape, and enter, home, esc, left, right, up, and down, 0 and 229 added for samsung keyboard
      if (e.shiftKey === false && $.inArray(keyID, [46, 8, 9, 27, 13, 35, 36, 37, 38, 39, 40, 0, 229]) !== -1) {
        // console.log('this key is allowed');
      } else {
        // Ensure that it is NOT a number and stop the keypress
        // https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
        // keyIDs across the top: 48-57
        // keyIDs on numeric keypad (FF) 96-105
        if (keyID < 48 || (keyID > 57 && keyID < 96) || keyID > 105) {
          e.preventDefault();
        }
      }
    },

    // do NOT allow numbers
    noNumbersInput: function (e, isKeyId) {
      // handle firefox
      // var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
      var keyID;
      if (isKeyId) {
        // var char = e.data;
        // console.log('e', e);
        keyID = e.which;// char.charCodeAt(0);
      } else {
        keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
      }
      // console.log('ALPHA >> keyID', keyID, 'char', char, 'keyCode', e.keyCode);
      // Allow: backspace, delete, tab, escape, and enter, home, esc, left, right, up, and down, 0 and 229 added for samsung keyboard
      // Ensure that it is NOT a number and stop the keypress
      // if (keyID > 47 && keyID < 58 || keyID > 95 && keyID < 106) {
      if (keyID > 47 && keyID < 58) {
        e.preventDefault();
      }
    },
    cityStateInput: function (e, isKeyId) {
      // handle firefox
      // var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
      var keyID;
      if (isKeyId) {
        // var char = e.data;
        // console.log('e', e);
        keyID = e.which;// char.charCodeAt(0);
      } else {
        keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
      }
      // console.log('ALPHA >> keyID', keyID, 'char', char, 'keyCode', e.keyCode);
      // Allow: space, backspace, delete, tab, escape, and enter, home, esc, left, right, up, and down, 0 and 229 added for samsung keyboard, comma, comma
      if (e.shiftKey === false && $.inArray(keyID, [32, 46, 8, 9, 27, 13, 35, 36, 37, 38, 39, 40, 0, 229, 188, 44]) !== -1) {

      } else {
        if (!(keyID >= 65 && keyID <= 122))
        {
          e.preventDefault();
        }
      }
    },

    showConfirmZipChangeModal: function (zip, isSkipConfirmZipChangeModal, continueCallback) {
      // console.log('showConfirmZipChangeModal');
      var _this = this;
      var $zipModalConfirm = $('#zip-modal-confirm');
      var $zipModalConfirmHeading = $zipModalConfirm.find('.body-copy');
      var $modalBackdrop = $('.modal-backdrop');
      var resultTemplate;
      var resultHandlebar;

      // check if skipping confirm zip change modal
      if (isSkipConfirmZipChangeModal) {
        // skip confirm zip change modal, so just continue
        if (continueCallback) {
          continueCallback();
        }
      } else {
        // remove our pageLoader that may have been set
        /*
        //BAT-3143
        var $pageLoader = $('#page-loader');
        var pageLoaderVisible = $pageLoader.is(':visible');
        if (pageLoaderVisible) {
          window.bat.util.loader.hideLoader();
        }
        */
        if ($zipModalConfirmHeading.data('template')) {
          // modal previously used, so get template from data
          resultTemplate = $zipModalConfirmHeading.data('template');
        } else {
          // modal not previously used, so get template from html
          resultTemplate = $zipModalConfirmHeading.html();
          // save template for later use
          $zipModalConfirmHeading.data('template', resultTemplate);
        }

        // evaluate template
        resultHandlebar = Handlebars.hcompile(resultTemplate, { zip: zip });

        // launch modal to confirm zip change
        $zipModalConfirmHeading.html(resultHandlebar);

        // launch modal
        $zipModalConfirm.modal('show');

        // set up modal events
        $zipModalConfirm.find('.modal-continue').off('click').on('click', function () {
          // hide the modal and fire continueCallback
          $zipModalConfirm.modal('hide');
          if (continueCallback) {
            continueCallback();
          }
        });

        $zipModalConfirm.find('.modal-cancel').off('click').on('click', function () {
          // hide the modal and do nothing else
          $zipModalConfirm.modal('hide');
          $modalBackdrop.hide();
          // reset inputs to OG zip here, if zip is already confirmed
          // else, set to empty string
          if (SU.isConfirmedZip()) {
            _this.updateZipFields(SU.getZip());
          } else {
            _this.updateZipFields('');
          }
        });

        $('.close-ground').off('click').on('click', function (e) {
          $zipModalConfirm.modal('hide');
          $modalBackdrop.hide();
          // reset inputs to OG zip here
          if (SU.isConfirmedZip()) {
            _this.updateZipFields(SU.getZip());
          }
        });

        // if user cancels the modal
        $zipModalConfirm.off('hidden.bs.modal').on('hidden.bs.modal', function () {
          // BAT-3146 , captures escape button.

          var participant = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
          if (SU.isConfirmedZip()) {
            // not possible? They've moved on to their TDA
          } else if (participant) {
            var dealer_code_rti = cookies.getItem('dealer_code_rti');
            if (dealer_code_rti == null) {
              window.fmp.refuseSelect();
            }
            if (zipTools.verifyConfirmedZip()) {
              window.zipTools.updateZipFields(SU.getZip());
            } else {
              window.zipTools.updateZipFields('');
            }
          }
          window.bat.util.loader.hideLoader();

          $zipModalConfirm.off('hidden.bs.modal');
        });
      }
    },

    showConfirmDealerModal: function (templateData, callback) {
      var $dealerConfirmModal = $('#dealer-confirm-modal');
      // if dealer-modal is already open, stop (can happen if user is changing zip via auto-submit, but also hits return)
      if ($('body').hasClass('modal-open')) {
        return false;
      }

      // remove our pageLoader that may have been set
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */

      // Dealer Confirm Modal
      if ($dealerConfirmModal.length) {
        var resultTemplate = $dealerConfirmModal.html();
        var resultHandlebar = Handlebars.hcompile(resultTemplate, { result: templateData });
        $('#modal-wrap-dealer').html(resultHandlebar);
      }

      // launch modal
      $('#dealer-modal').modal('show');
      $('#dealer-modal').focus();
      $('#dealer-modal').find('.modal-select').off('click').on('click', function (e) {
        e.preventDefault();
        var dealerCode = $(this).attr('modal-select');
        if (callback) {
          callback(dealerCode);
        }
      });
    },

    /*--------------------------------------------------------------------------------------------
    If response from /BATWS/geo/rest/geoLocation/getGeoInfo?zipcode=XXXXX contains a redirectUrl,
    that means that the 'dealer' for the provided zip is actually an external website.
    This modal let's them know that. BAT-2044: for specific zips we display City, Country within
    the modal as well.

    BAT-2044: There's an inline version of this modal as well (set the inline argument to true)
    in use on dealer search results page.
    BAT-
    --------------------------------------------------------------------------------------------*/
    showDealerRedirectModal: function (newZip, redirectUrl, inline) {
      // if dealer-redirect-modal is already open, stop (can happen if user is changing zip via auto-submit, but also hits return)
      if ($('body').hasClass('modal-open')) {
        return false;
      }

      // remove our pageLoader that may have been set
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */
      var _this = this;
      var $dealerRedirectModal = $('#dealer-redirect-modal');
      // Prettify the redirectUrl for use in the modal
      // TODO: this should be utility that returns whatever part
      // of a URL that you'd like (see also storage-util.js swapLangInUrl)
      var redirectArr = redirectUrl.split('/');
      var hrefShort = redirectArr[2];
      hrefShort = hrefShort.replace('www.', '');

      // setup data for Handlebars template
      var resultData = {
        'location': '',
        'hrefShort': hrefShort
      };

      // BAT-2044, Hawaii, Puerto Rico and Virgin Island redirects
      if (redirectUrl.indexOf('hawaii.com') !== -1 || redirectUrl.indexOf('hawaii.do') !== -1) {
        // if a dealer-search-page or SLP Lead form page, redirect to toyotahwaii.com/find-a-dealer
        if ($('#dealer-search-page').length > 0 || $('#request-a-quote, #schedule-test-drive, #contact-a-dealer').length > 0) {
          redirectUrl = 'http://www.toyotahawaii.com/find-a-dealer';
        } else {
          redirectUrl = 'http://www.toyotahawaii.com';
        }

        resultData.location = 'Hawaii';
      } else if (redirectUrl.indexOf('hawaii.do') !== -1) {
        redirectUrl = 'http://www.toyotahawaii.com';
        resultData.hrefShort = 'toyotahawaii.com';
        resultData.location = 'Hawaii';
      } else if (redirectUrl.indexOf('www.toyotapr.com') !== -1) {
        resultData.location = 'Puerto Rico';

      // scion puerto rico redirectUrls are not proper, so set them here
      } else if (redirectUrl.indexOf('puertoRico.do') !== -1) {
        redirectUrl = 'http://www.toyotapr.com';
        resultData.location = 'Puerto Rico';
        resultData.hrefShort = 'toyotapr.com';
      } else if (redirectUrl.indexOf('toyotavi') !== -1) {
        resultData.location = 'Virgin Islands';
        resultData.hrefShort = 'toyotavi.com';

      // just show zip for all others
      } else {
        resultData.location = newZip;
      }

      var resultTemplate = $dealerRedirectModal.html();
      var resultHandlebar = Handlebars.hcompile(resultTemplate, resultData);

      $('#modal-wrap-redirect').html(resultHandlebar);

      if (inline) {
        var redirectHtml = $(resultHandlebar).html();
        $('.js-results-present').css('opacity', '1'); // show the results in dealers page
        $('form.m-dealer-search').removeClass('is-loading');
        $('#search-submit').prop('disabled', false);
        $('#search-result-wrap').removeClass('view-results-visible');
        $('#search-result-wrap').before('<div id="js-dealer-redirect" class="modal-inline">' + redirectHtml + '</div>');

        $('#js-dealer-redirect').on('click', '.modal-continue', function () {
          cookies.setItem('transferZip', newZip, new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
          window.open(redirectUrl, '_blank');
        });
      } else {
        $('#dealer-redirect-confirm').modal('show').on('click', '.modal-continue', function () {
          cookies.setItem('transferZip', newZip, new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
          window.open(redirectUrl, '_blank');
        });
        // BAT-3296 if 'Leave' Modal is dismissed, set default zip in background
        $('#dealer-redirect-confirm').off('hidden.bs.modal').on('hidden.bs.modal', function () {
          window.fmp.refuseSelect();
        });
      }
    },

    showClickDealerModal: function (templateData, callback) {
      var $dealerConfirmModal = $('#click-to-dealer-modal');

      // remove our pageLoader that may have been set
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */
      // Dealer Confirm Modal
      if ($dealerConfirmModal.length) {
      // console.log("In if: ", );
        var resultTemplate = $dealerConfirmModal.html();
        var resultHandlebar = Handlebars.hcompile(resultTemplate, { result: templateData });
        $('#modal-click-to-dealer').html(resultHandlebar);
      }

      // launch modal
      $('#ctdealer-modal').modal('show');
      $('#ctdealer-modal').focus();

      if (SU.isConfirmedZip() !== true) {
        $('#zip-ctd-modal #dealer-results').hide(); // where is this?
      }

      $('#ctdealer-modal').find('.modal-select').off('click').on('click', function (e) {
        e.preventDefault();
        var dealerURL = $(this).attr('modal-select');
        if (callback) {
          callback(dealerURL);
        }
      });

      $('.close-ground').on('click', function () {
        $('#ctdealer-modal').hide();
        $('.modal-backdrop').hide();
      });
    },

    // FMP/GXP isInventoryModal, isOffersModal
    showInvalidZipModal: function (currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal) {
      // console.log('showInvalidZipModal');
      var _this = this;
      var $zipModalInvalid = $('#zip-modal-invalid');
      var $modalSearchField = $('#zip-modal-invalid input[name=modal-zip]');
      var $modalBackdrop = $('.modal-backdrop');
      var isInventoryModal = isInventoryModal || false;
      var isOffersModal = isOffersModal || false;

      $modalSearchField.val('');

      if (newZip) {
        $modalSearchField.val(newZip);
      }

      // if we're showing one of our page-loaders, close that first
      // these page loaders are new as of 8/4/16
      // and are usually found inline in XSL files (see vehicle-info.xsl)
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */

      // launch modal
      $zipModalInvalid.modal('show');
      $modalSearchField.focus();

      $zipModalInvalid.find('.modal-submit').off('click').on('click', function () {
        var newZipFromModal = $modalSearchField.val();
        $zipModalInvalid.modal('hide');
        setTimeout(function () {
          _this.changeZip(currentZip, newZipFromModal, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
        }, 300);
      });

      $('.close-ground').off('click').on('click', function () {
        $zipModalInvalid.modal('hide');
        // BAT-3146 capture close clicks.
        window.bat.util.loader.hideLoader();
        $modalBackdrop.hide();
      });

      $zipModalInvalid.off('hidden.bs.modal').on('hidden.bs.modal', function () {
        // BAT-3146 , captures escape button.
        // TODO: if zip is still invalid on close, we need to reset the UI to whatever the user had before
        if (SU.isConfirmedZip() === true) {
          window.zipTools.updateZipFields(SU.getZip());
        } else {
          window.zipTools.updateZipFields('');
        }
        window.bat.util.loader.hideLoader();
      });

      $modalSearchField.off('keyup').on('keyup', function (e) {
        var maxLen = parseInt($modalSearchField.attr('maxlength'));
        var myLen = $modalSearchField.val().length;
        var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

        switch (keyID) {
          // User has hit tab key (9) or return key (13)
          // hide the modal and fire continueCallback
          // case 9:
          case 13:
            var newZipFromModal = $modalSearchField.val();
            // hide the modal and fire continueCallback
            $zipModalInvalid.modal('hide');
            setTimeout(function () {
              _this.changeZip(currentZip, newZipFromModal, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
            }, 300);

            break;
          // User has hit escape key (27) or home key (36)
          // hide modal and do nothing else
          case 27:
          case 36:
            $zipModalInvalid.modal('hide');
            break;
          default: break;
        }

        // auto submit if maxlength is met (and not came into focus using TAB BAT-4783)
        if (maxLen === myLen && keyID !== 9) {
          var newZipFromModal = $modalSearchField.val();
          $zipModalInvalid.modal('hide');
          setTimeout(function () {
            _this.changeZip(currentZip, newZipFromModal, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
          }, 300);
        }
      });
      // BAT-4783 move TAB event from keyup to keydown handler
      /*
      $modalSearchField.off('keydown').on('keydown', function (e) {
        var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

        switch (keyID) {
          // User has hit tab key (9)
          // hide the modal and fire continueCallback
          case 9:
            var newZipFromModal = $modalSearchField.val();
            // hide the modal and fire continueCallback
            $zipModalInvalid.modal('hide');
            setTimeout(function () {
              _this.changeZip(currentZip, newZipFromModal, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
            }, 300);

            break;
          default: break;
        }
      });
      */
    },

    /*----------------------------------------------------
    FMP-6, adds isInventoryModal argument. Pass in true
      for 'Searching for Inventory' modal
    ------------------------------------------------------*/
    showPromptUserZipModal: function (currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isSmartPath, isOffersModal) {
      if (isSmartPath) {
        window.zipTools.isSmartPath = true;
      }
      // console.log('showPromptUserZipModal A:',currentZip, 'B:', newZip, 'C:', redirectPath, 'D:', finalCallback, 'E:', isSkipConfirmZipChangeModal, 'F:', isInventoryModal, 'G:', isSmartPath);
      var _this = this;
      var $zipModalPrompt = $('#zip-modal-prompt');
      var $modalSearchField = $('#zip-modal-prompt input[name=modal-zip]');
      var $modalBackdrop = $('.modal-backdrop');
      var isInventoryModal = isInventoryModal || false;
      var isOffersModal = isOffersModal || false;

      // Looking for Inventory? Zip code content
      if (isInventoryModal) {
        $zipModalPrompt.find('.js-zip-default').hide();
        $zipModalPrompt.find('.js-zip-inventory').show();
      } else {
        $zipModalPrompt.find('.js-zip-inventory').hide();
        $zipModalPrompt.find('.js-zip-default').show();
      }

      $modalSearchField.val('');

      if (newZip) {
        $modalSearchField.val(newZip);
      }

      // launch modal to get zip
      $zipModalPrompt.modal('show').css({ display: 'block' });
      $modalSearchField.focus();

      // User has continued with zip code, wether by clicking, filling out the input or on modal close (GXP);
      var zipModalContinue = function () {
        var newZipFromModal = $modalSearchField.val();
        // GXP, if TDA participates in GXP/FMP, and we're in zipModalContinue, that means they DID submit a zip code
        // as opposed to NOT submitting a zip code (that flow is handled via close modal below)
        var participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
        if (participantTDA) {
          $zipModalPrompt.off('hidden.bs.modal');
          // console.log('GXP: user did not close modal via close, esc or X button, removed hidden.bs.modal listener');
        }
        $zipModalPrompt.modal('hide');
        setTimeout(function () {
          _this.changeZip(currentZip, newZipFromModal, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
        }, 300);
      };

      $zipModalPrompt.find('.modal-continue').off().on('click', function () {
        zipModalContinue();
      });

      $zipModalPrompt.find('.modal-cancel').off().on('click', function () {
        // hide the modal and delete the cookie
        $zipModalPrompt.modal('hide');
        $modalBackdrop.hide();
        document.cookie = 'state=' + null + '; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        cookies.setItem('geoIgnore', 'true', new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
      });

      $('.close-ground').off('click').on('click', function () {
        $zipModalPrompt.modal('hide');
        $modalBackdrop.hide();
        cookies.setItem('geoIgnore', 'true', new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
      });

      $zipModalPrompt.off('hidden.bs.modal').on('hidden.bs.modal', function (event) {
        // If this is a participating TDA, we need to consider the ZIP as entered, even if the User
        // did not click continue.
        var newZipFromModal = $modalSearchField.val();
        var participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
        if (participantTDA) {
          // set TEMP zip in case they dismiss one of the several next modals?
          // $zipModalPrompt.modal('hide');
          var dealer_code_rti = cookies.getItem('dealer_code_rti');
          if (dealer_code_rti == null) {
            window.fmp.refuseSelect();
          }
        }
        if (zipTools.verifyConfirmedZip()) {
          window.zipTools.updateZipFields(SU.getZip());
        } else {
          window.zipTools.updateZipFields('');
        }
        $zipModalPrompt.off('hidden.bs.modal');
      });

      $modalSearchField.off('keyup').on('keyup', function (e) {
        var maxLen = parseInt($modalSearchField.attr('maxlength'));
        var myLen = $modalSearchField.val().length;
        var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

        switch (keyID) {
          // User has hit tab key (9) or return key (13)
          // hide the modal and fire continueCallback
          // case 9:
          case 13:
            zipModalContinue();
            break;
          // User has hit escape key (27) or home key (36)
          // hide modal and do nothing else
          case 27:
          case 36:
            $zipModalPrompt.modal('hide');
            break;
          default: break;
        }

        // auto submit if maxlength is met (and not came into focus using TAB BAT-4783)
        if (maxLen === myLen && keyID !== 9) {
          zipModalContinue();
        }
      });
      // BAT-4783 move TAB event from keyup to keydown handler
      /*
      $modalSearchField.off('keydown').on('keydown', function (e) {
        var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

        switch (keyID) {
          // User has hit tab key (9)
          // hide the modal and fire continueCallback
          case 9:
            zipModalContinue();
            break;
          default: break;
        }
      });
      */
    },

    isZipFormatValid: function (testZip) {
      var pattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      return pattern.test(testZip);
    },

    isValidNewZip: function (currentZip, newZip) {
      var _this = this;
      return _this.isZipFormatValid(newZip);
    },

    getTDA: function (zip, callback) {
      var defaultTDAZip = tdaConfig.tda.default_zip;
      if (zip == null || zip === 'undefined' || zip === '') {
        zip = defaultTDAZip;
      }
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/geoLocation/getGeoInfo',
        data: {
          zipcode: zip
        },
        success: function (data, textStatus, xhr) {
        },
        error: function (request, error) {
        }
      }).done(function (data) {
        if ($('a[data-omni_link="build-and-price"]').length) {
          $('a[data-omni_link="build-and-price"]').attr('href', 'http://www.toyota.com/configurator/?zipcode=' + zip);
        }

        // Added when completing BAT-2044, if there's a service error, show the error modal?
        if (data.serviceError != null) {
          redirectUrl = null; // a new serviceError has been returned, reset global redirectUrl

          if (data.serviceError != null && data.serviceError.redirect != null && data.serviceError.redirect.redirectUrl != null) {
            redirectUrl = data.serviceError.redirect.redirectUrl;
          }

          if (data.serviceError != null && data.serviceError.Redirect != null && data.serviceError.Redirect.redirectUrl != null) {
            redirectUrl = data.serviceError.Redirect.redirectUrl;
          }
        }

        if (callback) {
          callback(data);
        }
      }).fail(function (jqXHR, textStatus, errorThrown) {
        // console.log('ERROR');
        // console.log(textStatus, errorThrown);
        $('#service-error-modal').modal('show');
        // BAT-3146
        $('#service-error-modal').on('hidden.bs.modal', function () {
          window.bat.util.loader.hideLoader();
        });
      });
    },

    changeZip: function (currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal) {
      var changeZipData = {
        currentZip: currentZip,
        newZip: newZip,
        redirectPath: redirectPath,
        finalCallback: finalCallback,
        isSkipConfirmZipChangeModal: isSkipConfirmZipChangeModal,
        isInventoryModal: isInventoryModal,
        isOffersModal: isOffersModal
      };
      var dealer_code_rti = docCookies.getItem('dealer_code_rti');
      // if they already have a GXP dealer saved OR if this is a GXP entry point, and NO dealer has been selected.
      var isGxpEntryPage = window.location.href.indexOf('inventory/results') > -1 || window.location.href.indexOf('inventory-detail') > -1 || window.location.href.indexOf('offer-detail') > -1;
      var isFmpEntryPage = window.location.href.indexOf('inventory/local-results') > -1;
      var gxpFmpEntered = docCookies.getItem('dealer_gxp_fmp_Entered'); // prevent user from entering the second time around
      var participant = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';

      if (participant) {
        if (dealer_code_rti === 'true' || (isGxpEntryPage && gxpFmpEntered == null) || (isFmpEntryPage && gxpFmpEntered == null)) {
          // changeZIp process for RTI dealers, is handled in gxp.js, ZIP_CODE_FLOW_ENTER listener
          $(window).trigger('ZIP_CODE_RTI_FLOW_ENTER', changeZipData);
          gxpFmpEntered = true;
          return false;
        }
      }
      // console.log(' ::: changeZip:redirectPath:', redirectPath);
      var _this = this;
      window.bat.util.loader.showLoader(true); // Show page loader before modal //BAT-3009. DON'T NEED THIS ANYMORE.

      if (newZip === '' || $.trim(newZip) === '') {
        newZip = currentZip;
      }

      // verify valid new zip
      if (_this.isValidNewZip(currentZip, newZip)) {
        /*---------------------------------------------------------------------------------
        BAT-1554 & BAT-1919
        IF on the national site and user changes zip, and we're certain a TDA version of the
        page the user is on, exists, then let's supply that as our redirectPath to the promptUserForZip() function.
          - Scenarios where we know we can supply a redirectPath:
          Any Vehicle page $('input.vehicle-series').length
        ---------------------------------------------------------------------------------*/
        if (_this.getCurrentTDACode().toUpperCase() === 'WWW') {
          var $seriesInput = $('input.vehicle-series');
          if ($seriesInput.length && redirectPath.indexOf('/offers') >= 0) {
            var series = $seriesInput.val();
            redirectPath = '/offers/' + series + '/';
          } else if ($seriesInput.length && redirectPath.indexOf('/inventory') >= 0) {
            var series = $seriesInput.val();
            redirectPath = '/inventory/results/?series=' + series + '&brand=toyota';
          }
        }

        redirectPath = redirectPath || '/';

        // get TDA for new zip
        // the response (dataDealers) contains the first five dealers for newZip provided
        _this.getTDA(newZip, function (dataDealers) {
          /*
          console.group('dataDealers.entityList:');
          console.table(dataDealers.entityList);
          console.groupEnd();
          */
          // check that dealers were returned
          if (dataDealers && dataDealers.entityList && dataDealers.entityList.length) {
            var newDealer;
            // check for tda conflict
            if (dataDealers.conflict) {
              // console.debug('yes conflict');

              // tda conflict, gather dealerLocator info
              // Does this work? _getConfirmDealerTemplateData returns nothing if dealerLocator info
              confirmDealerTemplateData = _this._getConfirmDealerTemplateData(dataDealers.entityList);

              // check that we have a confirm dealer template data
              if (confirmDealerTemplateData && confirmDealerTemplateData.length > 1) {
                // console.debug('yes confirmDealerTemplateData');

                // make sure last modal has time to close
                setTimeout(function () {
                  // pass dataDealers data to modal
                  _this.showConfirmDealerModal(confirmDealerTemplateData, function (newDealerCode) {
                    var newDealerGrepResults = [];

                    // find the dealer object so we can check its TDA
                    newDealerGrepResults = $.grep(dataDealers.entityList, function (element, index) {
                      return element.dealerCode == newDealerCode;
                    });

                    // found the new dealer
                    if (newDealerGrepResults.length) {
                      newDealer = newDealerGrepResults[0];
                      // complete the zip change
                      _this._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal);
                    }
                  });
                }, 300);
              } else {
                // no confirm dealer template data, use first dealer
                newDealer = dataDealers.entityList[0];
                // complete the zip change
                _this._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
              }

              // Are we coming from an inventory based modal-zip-change? Pass in ALL the dealers!
            } else if (isInventoryModal || window.zipTools.isSmartPath) {
              if (window.zipTools.isSmartPath) {
                redirectPath = ('/' + tdaConfig.site.context_url + '/inventory/');
                // console.log(' ::: CHANGE ZIP, ', redirectPath);
              }
              // alert('user about to change zip');
              _this._changeZipComplete(currentZip, newZip, redirectPath, dataDealers, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
            } else if (isOffersModal) {
              _this._changeZipComplete(currentZip, newZip, redirectPath, dataDealers, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
            } else {
              // console.debug('no conflict');
              // no tda conflict, use first dealer
              newDealer = dataDealers.entityList[0];
              // complete the zip change
              _this._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
            }
          } else {
            // no dealers returned, but if there's a redirectUrl (returned in service 'error'), show dealer (external site) redirect modal.
            if (redirectUrl != null) {
              _this.showDealerRedirectModal(newZip, redirectUrl, false);

            // No dataDealers, and no redirectUrl, BAT-2044, check if this is a Virgin Islands zip
            } else if (_this.checkVirginIslands(newZip)) {
              _this.showDealerRedirectModal(newZip, 'http://www.toyotavi.com', false);

            // else, assume zip is invalid
            } else {
              // make sure last modal has time to close
              setTimeout(function () {
                _this.showInvalidZipModal(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
              }, 300);
            }
          }
        });
      } else {
        if (!_this.isZipFormatValid(newZip)) {
          // zip format is invalid
          // make sure last modal has time to close
          setTimeout(function () {
            // if zip invalid, show invalid modal
            _this.showInvalidZipModal(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal);
          }, 300);
        } else {
          // new zip invalid, so zip is unchanged
          _this.updateZipFields(currentZip);
          if (finalCallback) {
            finalCallback(currentZip);
          }
        }
      }
    }, // END changeZip

    changeZipForDeepLink: function (currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal) {
      // console.log('changeZipForDeepLink');
      var _this = this;
      window.bat.util.loader.showLoader(true); // Show page loader before modal

      // verify valid new zip
      if (_this.isValidNewZip(currentZip, newZip)) {
        redirectPath = redirectPath || '/';

        // get TDA for new zip
        _this.getTDA(newZip, function (pmaDealers) {
          // check that dealers were returned
          if (pmaDealers && pmaDealers.entityList && pmaDealers.entityList.length) {
            // console.debug('yes pmaDealers: ' + pmaDealers);
            var confirmDealerTemplateData;
            var newDealer;

            // check for tda conflict
            if (pmaDealers.conflict) {
              // tda conflict, gather dealerLocator info
              confirmDealerTemplateData = _this._getConfirmDealerTemplateData(pmaDealers.entityList);

              // check that we have a confirm dealer template data
              if (confirmDealerTemplateData && confirmDealerTemplateData.length > 1) {
                // console.debug('yes confirmDealerTemplateData');

                // make sure last modal has time to close
                setTimeout(function () {
                  // pass pmaDealers data to modal
                  _this.showConfirmDealerModal(confirmDealerTemplateData, function (newDealerCode) {
                    var newDealerGrepResults = [];

                    // find the dealer object so we can check its TDA
                    newDealerGrepResults = $.grep(pmaDealers.entityList, function (element, index) {
                      return element.dealerCode == newDealerCode;
                    });

                    // found the new dealer
                    if (newDealerGrepResults.length) {
                      newDealer = newDealerGrepResults[0];

                      // complete the zip change
                      _this._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal);
                    }
                  });
                }, 300);
              } else {
                // no confirm dealer template data, use first dealer
                newDealer = pmaDealers.entityList[0];

                // complete the zip change
                _this._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal);
              }
            } else {
              // console.debug('no conflict');
              // no tda conflict, use first dealer
              newDealer = pmaDealers.entityList[0];

              // complete the zip change
              _this._changeZipCompleteForDeepLink(currentZip, newZip, redirectPath, newDealer, finalCallback, false);
            }
          } else {
            // no dealers returned, so assume zipcode is invalid
            if (redirectUrl != null) {
              _this.showConfirmZipChangeModal($('#headerZipInput').val(), false, function () {
                cookies.setItem('transferZip', $('#headerZipInput').val(), new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
                window.location.href = redirectUrl;
              });
            } else {
              // make sure last modal has time to close
              setTimeout(function () {
                // if zip invalid, show invalid modal
                _this.showInvalidZipModal(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal);
              }, 300);
            }
          }
        });
      } else {
        if (!_this.isZipFormatValid(newZip)) {
          // zip format is invalid
          // make sure last modal has time to close
          setTimeout(function () {
            // if zip invalid, show invalid modal
            _this.showInvalidZipModal(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal);
          }, 300);
        } else {
          // new zip invalid, so zip is unchanged
          _this.updateZipFields(currentZip);

          if (finalCallback) {
            finalCallback(currentZip);
          }
        }
      }
    }, // END changeZipForDeepLink

    continueCallback: function () {
      // empty function that doesn't do anything
      // there is a call to continueCallback(), but I can't find the actual
      // function anywhere
      // lad
    },

    _changeZipComplete: function (currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal) {
      var _this = this;
      var participant = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
      window.bat.util.loader.hideLoader();// BAT-3009
      /*------------------------------------------------------------------------------------------------
      FMP-6 & GXP, are we coming from an inventory-based zip code change?
      Only needed if current TDA contains participating dealers
      ------------------------------------------------------------------------------------------------*/
      // if (isInventoryModal) {
      if (isInventoryModal || window.zipTools.isSmartPath) { // BAT-2990, FINAL STEP FOR NO CONFIRMED ZIP. MAYBE NOT.
        // console.log('GXP: _changeZipComplete');
        var promisedZipContainsRti = window.fmp.zipContainsRti(newZip);
        var promisedZipContainsFmp = window.fmp.zipContainsFmp(newZip);
        // When both checks are done, if EITHER ONE is true, we need to show the Select Dealer overlay
        $.when(promisedZipContainsRti, promisedZipContainsFmp).done(function (RtiResponse, FmpResponse) {
          // console.log('GXP Garage RtiResponse: ', RtiResponse);
          // console.log('FmpResponse: ', FmpResponse);

          // we ARE in the FMP/RTI user-flow, AND the newZip participates in either FMP || RTI && we're NOT changing TDA Codes

          // TODO: WHY do we need to use window.fmp.firstMoverParticipantDisplay() when TDA isn't changing AND we have NO FMP or RTI participants?
          // test this WITH an active dealer, changing to a non-participant zip on the same TDA
          // if (participant && (RtiResponse || FmpResponse || (SU.getTDA() === newDealer.entityList[0].tdaCode && !window.zipTools.isSmartPath))) {
          // it's possible that the following if statement is what's wanted.
          if (participant && (RtiResponse || FmpResponse)) {
            /* CAN'T always just use window.fmp.firstMoverParticipantDisplay() here. Needs to be more like what's in AttachInventoryClicks.
            only show IF dealer contains RTI/FMP!!!
            use-case: NO-participants, multiple PMAs */
            window.fmp.firstMoverParticipantDisplay(newZip, newDealer, 1, 5, SU.getTDA(), true, false);
            return false;
          } else if (participant && !RtiResponse && !FmpResponse && (SU.getTDA() === newDealer.entityList[0].tdaCode)) {
            newDealer = newDealer.entityList[0];
            window.fmp.setDealerCookies(newDealer.dealerCode, 'false', 'false', newDealer.tdaCode, '');
            var moveOn = function () {
              SU.setZip(newZip);
              SU.setConfirmedZip(true);
              var curUrl = window.location.pathname + window.location.search;
              var properUrl = window.fmp.buildInventoryUrl();
              if (curUrl !== properUrl) {
                window.location.href = properUrl;
              }
            };
            // if we had an RTI dealer already (indicated by dealer_code_rti_code_temp)
            // we need to update garage
            var dealer_code_rti_code_temp = cookies.getItem('dealer_code_rti_code_temp');
            if (dealer_code_rti_code_temp != null) {
              window.DGDataHub.changeActiveDealer('Toyota').then(function () {
                window.fmp.removeDealerCookies();
                // console.log('GXP: updated dealer via changeActiveDealer(\'Toyota\')');
                moveOn();
              }).catch(function (error) {
                // console.log('GXP: changeActiveDealer update error: ', error);
                moveOn();
              });
            } else {
              moveOn();
            }
          } else {
            // NON partiicpating TDAs need this finalcallback here. (as well as smart path peoples)
            if (window.zipTools.isSmartPath || !participant) {
              newDealer = newDealer.entityList[0];
              window.zipTools.isSmartPath = false;
              finalCallback = function () {
                // NO FMP or RTI Dealers found, it's safe to get inventory URL if we're coming from inventory modal?
                window.location.href = redirectPath;
              };
              // re-invoke _changeZipComplete, this time setting isInventoryModal to false
              window.zipTools._changeZipComplete(currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal, false, false);
            } else {
              newDealer = newDealer.entityList[0];
              window.zipTools._changeZipComplete(currentZip, newZip, redirectPath, newDealer, undefined, isSkipConfirmZipChangeModal, false, false);
            }
            // newDealer = newDealer.entityList[0];
            // var redirectPath = window.fmp.buildInventoryUrl(false);
          }
        });
      } else if (isOffersModal) {
        // console.log('GXP: _changeZipComplete offers based');
        var promisedZipContainsRti = window.fmp.zipContainsRti(newZip);
        $.when(promisedZipContainsRti).done(function (RtiResponse) {
          // console.log('GXP Garage RtiResponse: ', RtiResponse);
          // window.fmp.firstMoverParticipantDisplay(newZip, newDealer, 1, 5, SU.getTDA(), false, true);
          // we ARE in the FMP/RTI user-flow, AND the newZip participates in either FMP || RTI
          if (participant && RtiResponse) {
          // if (participant && (RtiResponse || SU.getTDA() === newDealer.entityList[0].tdaCode)) {
            // we confirm it on click in first-mover-participant
            // our newDealer var here is actually a full list of dealers
            // SU.setZip(newZip);
            window.fmp.firstMoverParticipantDisplay(newZip, newDealer, 1, 5, SU.getTDA(), false, true);
            return false;
            // we ARE in the FMP user-flow, but the newZip is NOT a paticipant
            // we need to wipe out the finalCallback, update our dealer, so we can
            // properly get the tdaCode and continue on as originally intended
          // participating TDA, no RTI dealers, and NOT chaning TDAs
          } else if (participant && !RtiResponse && (SU.getTDA() === newDealer.entityList[0].tdaCode)) {
            newDealer = newDealer.entityList[0];
            window.fmp.setDealerCookies(newDealer.dealerCode, 'false', 'false', newDealer.tdaCode, '');
            var moveOn = function () {
              var finalUrl = window.fmp.buildOffersUrlRti();
              finalUrl.done(function (rtiUrl) {
                cookies.removeItem('dealer_code_rti_code_temp', '/');
                SU.setZip(newZip);
                SU.setConfirmedZip(true);
                window.zipTools.updateZipFields(SU.getZip());// update UI
                if (rtiUrl !== '') {
                  window.location.href = rtiUrl;
                } else {
                  SU.initFavorites(); // recheck if favs
                }
              });
            };
            // if we had an RTI dealer already (indicated by dealer_code_rti_code_temp)
            // we need to update garage
            var dealer_code_rti_code_temp = cookies.getItem('dealer_code_rti_code_temp');
            if (dealer_code_rti_code_temp != null) {
              window.DGDataHub.changeActiveDealer('Toyota').then(function () {
                window.fmp.removeDealerCookies();
                // console.log('GXP: updated dealer via changeActiveDealer(\'Toyota\')');
                moveOn();
              }).catch(function (error) {
                // console.log('GXP: changeActiveDealer update error: ', error);
                moveOn();
              });
            } else {
              moveOn();
            }
          } else {
            newDealer = newDealer.entityList[0];
            window.zipTools._changeZipComplete(currentZip, newZip, redirectPath, newDealer, undefined, isSkipConfirmZipChangeModal, false, false);
          }
        });
      } else {
        window.fmp.removeDealerCookies(); // FMP 6, remove FMP & RTI related cookies when user changes zip
        // has tdaCode changed?
        if (newDealer.tdaCode === _this.getCurrentTDACode()) {
          // update local storage
          _this._changeZipSetLocalStorage(newZip, true, currentZip);
          /*--------------------------------------------------------------------------------------------
          KAC-32, if user changed zip to one that is in the SAME TDA, we still need to
          get the state, and update stateName plate, but only IF the TDA is using this state-based
          nameplate setting (not many are, KC IS, as of 3/30/16). We can tell if a TDA is using this
          feature, if the DOM contains $('.sName');
          ----------------------------------------------------------------------------------------------*/
          var sName = $('.sName');
          if (sName.length) {
            _this.stateName();
          }
        } else {
          // make sure last modal has time to close
          setTimeout(function () {
            // tda has changed, so confirm before redirection
            _this.showConfirmZipChangeModal(newZip, isSkipConfirmZipChangeModal, function () {
              // if on national site, then save zip on national site before redirecting
              if (_this.getCurrentTDACode().toUpperCase() === 'WWW') {
                _this._changeZipSetLocalStorage(newZip, true, currentZip);
              }
              if (newDealer.tdaCode === 'SET10') { redirectPath = '/'; }
              // selected dealer means TDA changed, so update domain cookie and redirect
              cookies.setItem('transferZip', newZip, new Date(Date.now() + _this.transferZipCookieTTL), '/', _this.getCrossDomainCookieDomain());
              var gotourl = buildGoTo(newDealer.tdaCode, redirectPath);
              window.location.href = gotourl;
            });
          }, 300);
        }
        if ($('div[data-component-name="404"]').length) { // BAT-2426. REDIRECT TO OFFERS FROM NationalCTA.
          window.location.href = redirectPath;
        }
        if (finalCallback) {
          // finalCallback should be made aware if the users TDA changed.
          var tdaChanged = newDealer.tdaCode !== tdaConfig.tda.code;
          finalCallback(newZip, tdaChanged);
        }
      }
    }, // END _changeZipComplete


    _changeZipCompleteForDeepLink: function (currentZip, newZip, redirectPath, newDealer, finalCallback, isSkipConfirmZipChangeModal) {
      // console.log('_changeZipCompleteForDeepLink')
      var _this = this;

      // has tdaCode changed?
      if (newDealer.tdaCode === _this.getCurrentTDACode()) {
        // update local storage
        _this._changeZipSetLocalStorage(newZip, true, currentZip);

        if (finalCallback) {
          finalCallback(newZip);
        }
      } else {
        // make sure last modal has time to close
        setTimeout(function () {
          // tda has changed, so confirm before redirection
          _this.showConfirmZipChangeModal(newZip, true, true);
        }, 300);
      }
    }, // END _changeZipCompleteForDeepLink


    _changeZipSetLocalStorage: function (newZip, isConfirmedZip, currentZip) {
      // console.log('_changeZipSetLocalStorage')
      var _this = this;

      // update zip
      SU.setZip(newZip);

      // set zip confirmed (false if not passed in)
      SU.setConfirmedZip(!!isConfirmedZip);

      // add zip code to configurator link
      if ($('a[data-omni_link="build-and-price"]').length) {
        $('a[data-omni_link="build-and-price"]').attr('href', 'http://www.toyota.com/configurator/?zipcode=' + SU.getZip());
      }
      /* $('a').each(function(index) {
        if($(this).attr('href') != null && $(this).attr('href') !== '' && typeof $(this).attr('href') !== 'undefined' && $.trim($(this).attr('href')) !== '' && $(this).attr('href').indexOf('http://www.toyota.com/configurator/') !== -1){
          $(this).attr('href', 'http://www.toyota.com/configurator/?zipcode=' + SU.getZip());
        }
      }); */
      // add zip code to parts and service for link outs

      // update UI
      _this.updateZipFields(newZip);

      // fire zip event
      if (_this.isInitialZipCodeReceived) {
        // had a different zip before
        // console.log('ZIP_CODE_CHANGED');

        if (SU.getTDA() === 'SET10') {
          console.info('UPDATE SET');
          window.bat.updateSETLinks();
        }
        if (currentZip !== newZip) {
          $(window).trigger('ZIP_CODE_CHANGED');
        }
      } else {
        // first time getting a zip
        // console.log('INITAL_ZIP_CODE_RECEIVED');

        if (SU.getTDA() === 'SET10') {
          console.info('UPDATE SET');
          window.bat.updateSETLinks();
        }
        $(window).trigger('INITAL_ZIP_CODE_RECEIVED');
      }
    },

    // Despite the argument being named 'pmaDealerEntities', this can also handle non PMA dealers,
    // as long as they have dealerLocator data on them
    _getConfirmDealerTemplateData: function (pmaDealerEntities) {
      var templateData = [];
      var dealersWithDealerLocatorDetail = [];
      var i;
      var dealersWithDealerLocatorDetailCount;

      // filter dealers to dealers with dealer locator detail
      dealersWithDealerLocatorDetail = $.grep(pmaDealerEntities, function (element, index) {
        return !!element.dealerLocator;
      });

      // build template data
      for (i = 0, dealersWithDealerLocatorDetailCount = dealersWithDealerLocatorDetail.length; i < dealersWithDealerLocatorDetailCount; i++) {
        var externalDealerSite = '';
        $.each(dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].uricommunication, function (index, value) {
          if (value.channelCode.value === 'Website') {
            externalDealerSite = value.uriid.value;
          }
        });
        // console.log(' : externalDealerSite: ', externalDealerSite);
        templateData.push({
          name: dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
          city: dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
          state: dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
          dealer_url: externalDealerSite,
          dealer_code: dealersWithDealerLocatorDetail[i].dealerLocator.dealerId,
          proximity_measure: dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.proximityMeasureGroup.proximityMeasure.value,
          dataLayer: {
            'dealer_brand': 'toyota',
            'dealer_code': dealersWithDealerLocatorDetail[i].dealerLocator.dealerId,
            'dealer_name': dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
            'dealer_zipcode': dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
            'dealer_city': dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
            'dealer_state': dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
            'dealer_metro': dealersWithDealerLocatorDetail[i].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.divisionCode.name
          }
        });
      }

      return templateData;
    },

    showTDARedirectModal: function (continueCallback, cancelCallback) {
      // remove our pageLoader that may have been set
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */
      // console.log('showTDARedirectModal');
      var $tdaRedirectModal = $('#tda-redirect-confirm');
      // set up modal events
      $tdaRedirectModal.find('.modal-continue').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
        // hide the modal and fire continueCallback
        $('#tda-redirect-confirm').modal('hide');

        if (continueCallback) {
          continueCallback();
        }
      });

      $tdaRedirectModal.find('.modal-cancel, .close-ground').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
        // hide the modal and do nothing else
        $('#tda-redirect-confirm').modal('hide');
        $('.modal-backdrop').hide();
        if (cancelCallback) {
          cancelCallback();
        }
      });

      $tdaRedirectModal.off('keyup').on('keyup', function (e) {
        var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

        switch (keyID) {
          case 13:
            e.stopImmediatePropagation();
            // hide the modal and fire continueCallback
            $('#tda-redirect-confirm').modal('hide');

            if (continueCallback) {
              continueCallback();
            }
            break;

          case 27:
          case 36:
            e.stopImmediatePropagation();

            // hide the modal and do nothing else
            $('#tda-redirect-confirm').modal('hide');

            if (cancelCallback) {
              cancelCallback();
            }
            break;
          default: break;
        }
      });

      $tdaRedirectModal.find('.modal-dialog').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
      });

      $tdaRedirectModal.off('click').on('click', function (e) {
        e.stopImmediatePropagation();

        $('#tda-redirect-confirm').modal('hide');

        if (cancelCallback) {
          cancelCallback();
        }
      });

      // show modal
      $tdaRedirectModal.modal('show');
      // make sure body has modal-open class after hitting back button
      setTimeout(function () {
        $('body').addClass('modal-open');
      }, 300);
      $tdaRedirectModal.focus();
    },

    showExternalWebsiteModal: function (continueCallback, cancelCallback) {
      // remove our pageLoader that may have been set
      /*
      //BAT-3143
      var $pageLoader = $('#page-loader');
      var pageLoaderVisible = $pageLoader.is(':visible');
      if (pageLoaderVisible) {
        window.bat.util.loader.hideLoader();
      }
      */
      var $externalWebsiteModal = $('#external-website-confirm');
      // set up modal events
      $externalWebsiteModal.find('.modal-continue').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
        // hide the modal and fire continueCallback
        $externalWebsiteModal.modal('hide');

        if (continueCallback) {
          continueCallback();
        }
      });

      $externalWebsiteModal.find('.modal-cancel, .close-ground').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
        // hide the modal and do nothing else
        $externalWebsiteModal.modal('hide');
        $('.modal-backdrop').hide();
        if (cancelCallback) {
          cancelCallback();
        }
      });


      $externalWebsiteModal.find('.modal-dialog').off('click').on('click', function (e) {
        e.stopImmediatePropagation();
      });

      $externalWebsiteModal.off('click').on('click', function (e) {
        e.stopImmediatePropagation();
        $('#tda-redirect-confirm').modal('hide');

        if (cancelCallback) {
          cancelCallback();
        }
      });

      // show modal
      $externalWebsiteModal.modal('show');
      // make sure body has modal-open class after hitting back button
      setTimeout(function () {
        $('body').addClass('modal-open');
      }, 300);
      $externalWebsiteModal.focus();
    },

    warnOnTDAChange: function (event) {
      // console.log('warnOnTDAChange');
      var $this = $(this);
      var _this = window.zipTools;
      var currentTDACode = _this.getCurrentTDACode();

      if (currentTDACode !== $this.data('tdaCode')) {
        event.preventDefault();
        _this.showTDARedirectModal(function () {
          if ($this.data('tdaCode').toUpperCase() === 'SET10') {
            // window.location.href = 'http://southeast.buyatoyota.com/';
            window.location.href = 'https://www.buyatoyota.com/southeasttoyota/';
          } else {
            var gotourl = buildGoTo($this.data('tdaCode'), $this.attr('href'));
            window.location.href = gotourl;
          }
        });
      }
    },

    getSiteHomePath: function () {
      return '/' + tdaConfig.site.context_url + '/';
    },

    getCurrentTDACode: function () {
      var $regionName = $('#region-name');
      var currentTDACode = '';

      if ($regionName.length) {
        currentTDACode = $regionName.data('tdaCode').trim();
      }

      return currentTDACode;
    },

    initializeMaps: function () {
      // console.log('initializeMaps');
      var _this = this;
      var currentTDACode = _this.getCurrentTDACode();
      var setInitialZip = $.proxy(_this.setInitialZip, _this);
      var setDefaultZip = $.proxy(_this.setDefaultZip, _this);
      var promptUserForZip = $.proxy(_this.promptUserForZip, _this);

      var geoSuccess;
      try {
        if (navigator.geolocation) {
          // try geolocation
          // detect zip, provide successCallbak and failCallback
          var failCallback;
          if (SU.getTDA() === 'WWW') {
            failCallback = function () {
              window.zipTools.promptUserForZip(SU.getZip(), window.zipTools.redirectPath);
            };
            geoSuccess = $.proxy(_this.setInitialZipAndTransfer, _this);
          } else {
            failCallback = function () {
              setDefaultZip();
            };
            geoSuccess = $.proxy(_this.setInitialZipAndPromptForUserZip, _this);
          }
          _this.geoLocationZip.detect(geoSuccess, failCallback);
        } else {
          // no geolocation, just setDefaultZip in the background
          setDefaultZip();
        }
      } catch (e) {
        setDefaultZip();
      }
    },

    stateName: function () {
      var _this = this;
      googleMaps()
        .then(function (google) {
          new google.maps.Geocoder().geocode({ address: SU.getZip() }, function (result, status) {
            var state = 'N/A';
            // start loop to get state from zip
            for (var component in result[0]['address_components']) {
              for (var i in result[0]['address_components'][component]['types']) {
                if (result[0]['address_components'][component]['types'][i] === 'administrative_area_level_1') {
                  state = result[0]['address_components'][component]['long_name'];
                  SU.setState(state);
                  // do stuff with the state here!
                  _this.stateNameplate(SU.getState());
                }
              }
            }
          });
        })
        .catch(function (err) { console.warn('State Name Error ', err); });
    },

    stateNameplate: function (stateName) {
      var $sName = $('.sName');
      if ($sName.length) {
        $('.dZip').hide();
        $sName.html(stateName).show();
      }
    },

    checkVirginIslands: function (zip) {
      var virginIslandZips = ['00820', '00821', '00822', '00823', '00824', '00840', '00841', '00850', '00851', '00830', '00831', '00801', '00802', '00803', '00804', '00805'];
      if (virginIslandZips.indexOf(zip) !== -1) {
        return true;
      }
      return false;
    },

    autoLocate: function () {
      var self = this;
      var geoSuccess = function (returnedZip) {
        $('.modal input[data-storage="userZip"]').val(returnedZip);
      };
      var geoFail = function () {
        $('.modal.fade.in').find('.close-ground').trigger('click');
        $('#auto-locate-prompt').modal('show');
      };
      self.geoLocationZip.detect(geoSuccess, geoFail);
    },

    reLoadDealerSearch: function (newZip) {
      setTimeout(function () {
        $('#search-type').find('select').val('zip');
        $('#search-type').find('select').change();
        $('#search-value').val(newZip).removeClass('ui-state-error').addClass('ui-state-valid');
        $('#search-submit').trigger('click');
      }, 300);
    },

    reLoadDealerSearchWithoutZip: function () {
      // console.log('reLoadDealerSearchWithoutZip')
      $('#auto-locate-prompt').modal('show');
      // autolocate has failed, just show the prompt
      // do NOT trigger click on dealer search
      // setTimeout(function () {
      // 	$('#search-type').find('select').val('zip');
      // 	$('#search-type').find('select').change();
      // 	$('#search-value').val(SU.getZip());
      // 	$('#search-submit').trigger('click');
      // }, 300);
    }
  };


  // todo: move to require-config?
  $(window).on('loaded', function zipToolsLoaded() {
    zipTools.init();
  });
  return zipTools;
});

